// @flow
import React, { Component } from 'react';
import I18n from '../../../../../../lib/i18n';
import Details from '../Details';

export default class ActivationBonusDetails extends Component<Props> {
  render() {
    return (
      <Details
        icon="invitefriend"
        title={I18n.t('SignUp.ConfirmPlan.activationBonus.title')}
        subtitle={I18n.t('SignUp.ConfirmPlan.activationBonus.subtitle', {
          amount: I18n.toPrice(this.props.amount),
        })}
        isInvalid={this.props.isNotFirstSubscription}
      />
    );
  }
}

type Props = {
  amount: number,
  isNotFirstSubscription: boolean,
};
